export default __webpack_public_path__ + "static/media/IMG_2839.3928a666.JPG";